import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ImageUpdateService } from './image-update.service';
import { ActivatedRoute } from '@angular/router';
import { CatalogService } from '../catalog-api/catalog.service';
import { ToasterService } from 'angular2-toaster';
import { QAService } from '../qa/qa.service';
import { UserDetailsService } from '../../shared/user.details.service';
import { InAppNotificationsService } from '../../notifications/notifications.service';

@Component({
    selector: 'app-image-update',
    templateUrl: 'image-update.component.html',
    styleUrls: ['image-update.component.scss']
})
export class ImageUpdateComponent implements OnInit {
    @ViewChild('chartProdImage', {read: ElementRef}) chartProdImage: ElementRef;
    @ViewChild('posterProdImage', {read: ElementRef}) posterProdImage: ElementRef;
    @ViewChild('bannerProdImage', {read: ElementRef}) bannerProdImage: ElementRef;
    @ViewChild('chartQaImage', {read: ElementRef}) chartQaImage: ElementRef;
    @ViewChild('posterQaImage', {read: ElementRef}) posterQaImage: ElementRef;
    @ViewChild('bannerQaImage', {read: ElementRef}) bannerQaImage: ElementRef;
    @ViewChild('modal', {read: ElementRef}) modal: ElementRef;
    @ViewChild('rejectModal', {read: ElementRef}) rejectModal: ElementRef;
    @ViewChild('rejectModalImage', {read: ElementRef}) rejectModalImage: ElementRef;
    @ViewChild('modalImage', {read: ElementRef}) modalImage: ElementRef;
    @Input() selectedTitle: any;

    private chartDisplayQaButtons: boolean;
    private posterDisplayQaButtons: boolean;
    private bannerDisplayQaButtons: boolean;
    private chartQaProcessing = false;
    private posterQaProcessing = false;
    private bannerQaProcessing = false;
    private imageQaProcessing = false;
    private chartQaSuccess = false;
    private posterQaSuccess = false;
    private bannerQaSuccess = false;
    private chartQaTypeString: string;
    private posterQaTypeString: string;
    private bannerQaTypeString: string;
    private chartDimensions = {};
    private posterDimensions = {};
    private bannerDimensions = {};
    private chartImageState: string;
    private posterImageState: string;
    private bannerImageState: string;

    private chartImageUrl: string;
    private posterImageUrl: string;
    private bannerImageUrl: string;


    private chart: File;
    private poster: File;
    private banner: File;
    private imagesLoaded = {
        'chartProd': false,
        'chartQa': false,
        'chartModal': false,
        'bannerProd': false,
        'bannerQa': false,
        'bannerModal': false
    };

    /*
        Possible states are:
        - Present
        - Not Present
        - Pending
        - Present and Pending
        - Present and QA
    */

    private isExternalUser = true;
    private title: string;
    private displayName: string;
    private parrotId: string;
    private contentType: string;
    private uploadImage: Boolean = true;
    private IMAGE_LOCATION_PREFIX = 'https://cdn-fastly.parrotanalytics.com/images';
    private uploadingCount: number = 0;
    private username: string;
    private pageLoaded: boolean = false;
    private claimed = false;
    private claimLoading = true;
    private claimedByOther = false;
    private qaRequestExists = false;
    private qaRequestLoading = false;
    private prodImageQALoading = {
        chart: false,
        poster: false,
        banner: false
    };
    private prodQAImageLoading = false;
    private isAdmin = false;
    private rejectImageType;
    private rejectMessage;
    private rejectModalLoading = false;
    private pendingImagesUsers = {
        chart: undefined,
        poster: undefined,
        banner: undefined
    };
    private modalImageType: string = 'none';

    constructor(private imageUpdateService: ImageUpdateService,
        private route: ActivatedRoute,
        private catalogService: CatalogService,
        private toasterService: ToasterService,
        private qaService: QAService,
        private userDetailsService: UserDetailsService,
        private notificationsService: InAppNotificationsService) {}

    ngOnInit() {
        this.username = localStorage.getItem('userName');
        // Grab the metadata for the title if we have a path param.
        if (!this.route.snapshot.params['titleId']) {
            this.parrotId = this.selectedTitle.parrot_id;
            this.contentType = this.selectedTitle.content_type === undefined ? this.selectedTitle.content_type : this.selectedTitle.contentType;
            this.title = this.selectedTitle.metadata.title;
            this.displayName = this.selectedTitle.display_name;
            this.chartImageState = this.selectedTitle.metadata.images.chart;
            this.posterImageState = this.selectedTitle.metadata.images.poster;
            this.bannerImageState = this.selectedTitle.metadata.images.banner;
            // The catalog does not get refreshed automatically - however state may change meanwhile.

            // this.imageUpdateService.getImageUpdateRequest(this.parrotId)
            //     .then(res => {
            //         console.log('TEST1');
            //         console.log(res);
            //         this.chartImageState = res.promoted_poster.s3_url;
            //         this.posterImageState = res.promoted_poster.s3_url;
            //         this.bannerImageState = res.promoted_poster.s3_url;
            //         console.log(this.chartImageState);
            //         console.log(this.posterImageState);
            //         console.log(res);
            //
            //     }) .catch(err => {
            //     console.error('An error has occured', err);
            // });

            this.catalogService.getCatalogByContentType(this.selectedTitle.parrot_id, this.selectedTitle.content_type)
                .then(res => {
                    this.chartImageState = res.metadata[0].images.chart;
                    this.posterImageState = res.metadata[0].images.poster;
                    this.bannerImageState = res.metadata[0].images.banner;

                    this.getClaimForTitle();
                    this.getPendingUsersForTitle();
                    this.setImageSources();

                });

            this.getClaimForTitle();
            this.getPendingUsersForTitle();
            this.setImageSources();
        }

        // Get whether the user is an admin
        this.isAdmin = this.userDetailsService.isAdmin();

        // Subscribe to route changes so we can update the active title.
        this.route.params.subscribe(params => {
            if (params['titleId']) {
                this.parrotId = params['titleId'];
                this.getClaimForTitle();
                this.catalogService.getCatalogByContentType(params['titleId'], this.selectedTitle.content_type)
                .then(res => {
                    this.title = res.metadata[0].title;
                    this.chartImageState = res.metadata[0].images.chart;
                    this.posterImageState = res.metadata[0].images.poster;
                    this.bannerImageState = res.metadata[0].images.banner;
                    if (this.pageLoaded) {
                        // We need the view to be initialised so that the image references exist.
                        this.setImageSources();
                    }
                })
                .catch(err => {
                    console.error('An error has occured', err);
                });
            }
        });

        // Check if there exists an image QA request for this title
        this.checkPendingQARequest();
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngAfterViewInit() {
        if (this.chartImageState && this.posterImageState && this.bannerImageState) {
            // The image states have been loaded in so we can load the images in.
            this.setImageSources();
        }
        this.pageLoaded = true;
    }

    // ngOnChanges() {
    //     this.setImageSources();
    // }

    setImageSources() {
        // Look at the metadata image states and set the sourceces based off this:
        // - Present: Prod image set to S3, QA image set to default
        // - Not Present: Set both images to default
        // - Pending: Prod image to default, QA image set to S3
        // - Present and Pending: Prod image to S3, Qa image set to S3
        this.setImageSource('chart', this.chartImageState);
        this.setImageSource('poster', this.posterImageState);
        this.setImageSource('banner', this.bannerImageState);
    }

    setImageSource(imageType: string, imageState: string) {
        // If no image state, assume not present.
        if (!imageState) {
            imageState = 'Not Present';
        }


        const prodImage = this[`${imageType}ProdImage`];
        const qaImage = this[`${imageType}QaImage`];

        if ( imageType === 'banner') {
            imageType = 'background';
        }

        if ( this.selectedTitle.content_type === 'talent' && imageType === 'poster') {
            imageType = 'portrait';
        }

        const prodImageSrc = `${this.IMAGE_LOCATION_PREFIX}/${imageType}-hyphen/${this.parrotId}.jpg?unique=${Math.random()}`;
        const qaImageSrc = `${this.IMAGE_LOCATION_PREFIX}/qa/${imageType}/${this.parrotId}.jpg?unique=${Math.random()}`;

        if ( this.selectedTitle.content_type === 'talent' && imageType === 'portrait' ) {
            imageType = 'poster';
        }

        if ( imageType === 'background') {
            imageType = 'banner';
        }


        const defaultImageSrc = `/assets/img/placeholders/${imageType}-placeholder.jpg`;

        // console.log(prodImageSrc);


        switch (imageState) {
            case 'Present':
                prodImage.nativeElement.src = prodImageSrc;
                qaImage.nativeElement.src = defaultImageSrc;
                this[`${imageType}DisplayQaButtons`] = false;
                break;
            case 'Not Present':
                prodImage.nativeElement.src = prodImageSrc;
                qaImage.nativeElement.src = defaultImageSrc;
                this[`${imageType}DisplayQaButtons`] = false;
                break;
            case 'Pending':
                prodImage.nativeElement.src = defaultImageSrc;
                qaImage.nativeElement.src = qaImageSrc;
                this[`${imageType}DisplayQaButtons`] = true;
                break;
            case 'Present and Pending':
                prodImage.nativeElement.src = prodImageSrc;
                qaImage.nativeElement.src = qaImageSrc;
                this[`${imageType}DisplayQaButtons`] = true;
                break;
            case 'Present and QA':
                prodImage.nativeElement.src = prodImageSrc;
                qaImage.nativeElement.src = defaultImageSrc;
        }
    }

    getPendingUsersForTitle() {
        this.imageUpdateService.getImageUpdateRequest(this.parrotId, ['PENDING'])
            .then(res => {
                if (res.update_requests && res.update_requests.length > 0) {
                    // There can only ever be 3 pending
                    res.update_requests.forEach((item) => {
                        switch (item.image_type) {
                            case 'chart':
                                this.pendingImagesUsers.chart = item.idRequestUser;
                            // tslint:disable-next-line:no-switch-case-fall-through
                            case 'banner':
                                this.pendingImagesUsers.banner = item.idRequestUser;
                            // tslint:disable-next-line:no-switch-case-fall-through
                            case 'poster':
                                this.pendingImagesUsers.poster = item.idRequestUser;
                            // tslint:disable-next-line:no-switch-case-fall-through
                            default:
                                break;
                        }
                    });
                }
            });
    }

    getClaimForTitle() {
        this.imageUpdateService.getImageUpdateRequest(this.parrotId, ['CLAIMED'])
            .then(res => {
                if (res.update_requests && res.update_requests[0]) {
                    if (this.username === res.update_requests[0].idRequestUser) {
                        this.claimed = true;
                    } else {
                        this.claimedByOther = true;
                    }
                } else {
                    this.claimedByOther = false;
                }
                this.claimLoading = false;
            });
    }

    claimTitle() {
        this.claimLoading = true;
        // Try to claim the title.
        this.imageUpdateService.postClaimImage(this.parrotId, this.title, this.username)
            .then(res => {
                this.claimLoading = false;
                if (res.status === 200) {
                    // Image claimed, allow the user to upload.
                    this.claimed = true;
                } else {
                    // Image claim unsuccessful.
                    this.toasterService.pop('error', null, 'Unable to edit this image as it is already taken');
                }
            })
            .catch(err => {
                this.toasterService.pop('error', null, 'An internal server error has occured');
                console.error('An error has occured', err);
            });
    }

    unclaimTitle() {
        this.claimLoading = true;
        this.imageUpdateService.deleteClaimImage(this.parrotId)
            .then(res => {
                this.claimLoading = false;
                if (res.status === 200) {
                    // Image unclaimed.
                    this.claimed = false;
                } else {
                    this.toasterService.pop('error', null, 'Failed to unclaim image');
                }
            })
            .catch(err => {
                this.toasterService.pop('error', null, 'An internal server error has occured');
                console.error('An error has occured', err);
            });
    }

    onSelectImage(event, imageType: string) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();

            // Using any here because otherwise it complains about result not existing.
            reader.onload = (e: any) => {
                switch (imageType) {
                    case 'chart':
                        this.chartQaImage.nativeElement.src = e.target.result;
                        this.chart = event.target.files[0];
                        break;
                    case 'poster':
                        this.posterQaImage.nativeElement.src = e.target.result;
                        this.poster = event.target.files[0];
                        break;
                    case 'banner':
                        this.bannerQaImage.nativeElement.src = e.target.result;
                        this.banner = event.target.files[0];
                        break;
                }
            };

            reader.readAsDataURL(event.target.files[0]);
        }
    }

    submitImages() {
        // Validate that images are valid before starting
        let allImagesValid = true;
        ['chart', 'poster', 'banner'].map(imageType => {
            if (this[imageType] && this[imageType].size < 1048576 && !this.validateImage(imageType) && this.contentType && this.contentType.toLowerCase() !== "sports") {
                this.toasterService.pop('error', null, `The ${imageType} image does not meet the requirements!`);
                allImagesValid = false;
            } 
        });
        if (!allImagesValid) {
            return;
        }
        this.unclaimTitle();
       // console.log(this);
        ['chart', 'poster', 'banner'].map((imageType) => {
            // There has been an image uploaded and it is less than the max size.
            if (this[imageType] != null) {
                this.uploadingCount++;
                this.imageUpdateService.postImageUpdate(
                    this[imageType], this.username, this.parrotId, this.title, imageType,
                    this[`${imageType}ImageState`], this.selectedTitle.content_type)
                .then(res => {
                    this.uploadingCount--;
                    if (res.status === 200) {
                        this[imageType] = null;
                        this.pendingImagesUsers[imageType] = this.username;
                        this[`${imageType}DisplayQaButtons`] = true;
                        // Change the state of the image
                        if (this[`${imageType}ImageState`] === 'Not Present') {
                            this[`${imageType}ImageState`] = 'Pending';
                        } else if (this[`${imageType}ImageState`] === 'Present' ||
                            this[`${imageType}ImageState`] === 'Present and QA') {
                            this[`${imageType}ImageState`] = 'Present and Pending';
                        }
                        this.toasterService.pop('success', null, 'Successfully uploaded ' + imageType);
                    } else {
                        // Upload failed
                        this.toasterService.pop('error', null, 'Failed to upload ' + imageType);
                    }
                })
                .catch(err => {
                    this.toasterService.pop('error', null, 'An internal server error has occured');
                    console.error('An error occured', err);
                });
            }
        });
    }

    validateImage(imageType) {
        const dimensions = this[`${imageType}Dimensions`];
        if (!dimensions) {
            return false;
        }
        const ratio = dimensions.width / dimensions.height;
        switch (imageType) {
            case 'chart':
                if (dimensions.width < 250 || dimensions.height < 250 || ratio < 0.95 || ratio > 1.05) {
                    return false;
                }
                break;
            case 'poster':
                if (dimensions.width < 600 || dimensions.height < 1000 || ratio < 0.6 || ratio > 1.2) {
                    return false;
                }
                break;
            case 'banner':
                if (dimensions.width < 1280 || dimensions.height < 720 || ratio < 1.73 || ratio > 1.83) {
                    return false;
                }
                break;
        }
        return true;
    }

    clearImages() {
        this.chartQaImage.nativeElement.src = this.IMAGE_LOCATION_PREFIX + '/qa/chart-hyphen/' + this.parrotId + '.jpg';
        this.bannerQaImage.nativeElement.src = this.IMAGE_LOCATION_PREFIX + '/qa/banner-hypen/' + this.parrotId + '.jpg';
        this.posterQaImage.nativeElement.src = this.IMAGE_LOCATION_PREFIX + '/qa/poster-hypen/' + this.parrotId + '.jpg';
        this.chart = null;
        this.poster = null;
        this.banner = null;
    }

    imageLoad(imageType: string) {
        // This gets the dimensions of the image by creating an in-memory image element.
        const img = new Image();
        switch (imageType) {
            case 'chart':
                img.onload = () => {
                    this.chartDimensions = {
                        width: img.width,
                        height: img.height
                    };
                };
                img.src = this.chartQaImage.nativeElement.src;
                break;
            case 'poster':
                img.onload = () => {
                    this.posterDimensions = {
                        width: img.width,
                        height: img.height
                    };
                };
                img.src = this.posterQaImage.nativeElement.src;
                break;
            case 'banner':
                img.onload = () => {
                    this.bannerDimensions = {
                        width: img.width,
                        height: img.height
                    };
                };
                img.src = this.bannerQaImage.nativeElement.src;
                break;
        }
    }

    processImageQa(imageType: string, state: string) {
        this[`${imageType}DisplayQaButtons`] = false;
        this[`${imageType}QaProcessing`] = true;
        this.imageQaProcessing = true;
        this.imageUpdateService.putImageQa(this.parrotId, this.username, state, imageType,
            this[`${imageType}ImageState`],this.selectedTitle.content_type)
            .then(res => {
                this[`${imageType}QaProcessing`] = false;
                this.imageQaProcessing = false;
                if (res.status === 200) {
                    this[`${imageType}QaTypeString`] = state === 'APPROVED' ? 'approved' : 'rejected';
                    this[`${imageType}QaSuccess`] = true;
                } else {
                    this[`${imageType}DisplayQaButtons`] = true;
                    this.toasterService.pop('error', null, 'Failed to process QA request!');
                }
            })
            .catch(err => {
                this.imageQaProcessing = false;
                this[`${imageType}DisplayQaButtons`] = true;
                this[`${imageType}QaProcessing`] = false;
                this.toasterService.pop('error', null, 'An internal server error has occured');
                console.error('An error occured', err);
            });
    }

    displayQaButtons() {
        return (
                    this.chartDisplayQaButtons || this.posterDisplayQaButtons || this.bannerDisplayQaButtons ||
                    (
                        this.chartQaSuccess || this.posterQaSuccess || this.bannerQaSuccess ||
                        this.chartQaProcessing || this.posterQaProcessing || this.bannerQaProcessing
                    )
                ) && this.isAdmin;
    }

    openRejectModal(imageType: string) {
        // Will only ever be a QaImage
        const imageObject: ElementRef = this[`${imageType}QaImage`];
        this.rejectModalImage.nativeElement.src = imageObject.nativeElement.src;
        this.rejectImageType = imageType;
        this.rejectModal.nativeElement.style.display = 'block';
    }

    closeRejectModal(imageType: string) {
        this.rejectModal.nativeElement.style.display = 'none';
    }

    closeAndRejectModal() {
        this.rejectModalLoading = true;
        const imageType = this.rejectImageType;
        const imageTypeCapitalized = imageType[0].toUpperCase() + imageType.slice(1);
        this[`${imageType}DisplayQaButtons`] = false;
        this[`${imageType}QaProcessing`] = true;
        this.imageQaProcessing = true;
        // Do the regular QA process, but also create a notification for the user that uploaded the image
        Promise.all([
            this.imageUpdateService.putImageQa(this.parrotId, this.username, 'REJECTED', imageType,
                this[`${imageType}ImageState`], this.selectedTitle.content_type), ,
            this.notificationsService.postNotification(
                this.pendingImagesUsers[imageType],
                localStorage.getItem('userName'),
                `Image Processing: ${this.displayName} - ${imageTypeCapitalized} - Rejected`,
                this.rejectMessage
            )
        ])
        .then((res) => {
            // Handle the putImageQa response
            this[`${imageType}QaProcessing`] = false;
            this.imageQaProcessing = false;
            if (res[0].status === 200) {
                this[`${imageType}QaTypeString`] = 'rejected';
                this[`${imageType}QaSuccess`] = true;
            } else {
                this[`${imageType}DisplayQaButtons`] = true;
                this.toasterService.pop('error', null, 'Failed to process QA request!');
            }

            // Get rid of the modal
            this.rejectModalLoading = false;
            this.rejectModal.nativeElement.style.display = 'none';
        })
        .catch((err) => {
            this.rejectModalLoading = false;
            this.rejectModal.nativeElement.style.display = 'none';
            this.imageQaProcessing = false;
            this[`${imageType}DisplayQaButtons`] = true;
            this[`${imageType}QaProcessing`] = false;
            console.error('Failed to process image QA rejection and create a notification: ', err.toString());
        });
    }

    openImageModal(imageName: string) {
        const imageObject: ElementRef = this[imageName];
        this.modalImageType = imageName;
        this.modal.nativeElement.style.display = 'block';
        this.modalImage.nativeElement.src = imageObject.nativeElement.src;
    }

    closeImageModal() {
        this.modal.nativeElement.style.display = 'none';
    }

    checkPendingQARequest() {
        this.qaService.getLastPendingQARequest(this.parrotId, 'images')
            .then((res) => {
                this.qaRequestExists = res.qa_requests.length === 1;
            })
            .catch((err) => {
                const error = JSON.parse(err._body);
                console.error('Failed to create QA requests: ' + JSON.stringify(error));
                this.toasterService.pop('error', 'Failed to check for a pending QA request');
            });
    }

    handleQARequestApprove() {
        this.qaRequestLoading = true;
        const user = localStorage.getItem('userName');
        this.qaService.updateQARequest(this.parrotId, user, 'images')
        .then((res) => {
            this.qaRequestLoading = false;
            this.qaRequestExists = false;
            this.toasterService.pop('success', 'Successfully updated QA entry');
        })
        .catch((err) => {
            this.qaRequestLoading = false;
            const error = JSON.parse(err._body);
            console.error('Failed to update QA request: ' + error);
            this.toasterService.pop('error', 'Failed to update QA request');
        });
    }

    handleQARequestReject() {
        this.qaRequestLoading = true;
        const user = localStorage.getItem('userName');
        Promise.all([
            // Set QA to completed
            this.qaService.updateQARequest(this.parrotId, user, 'images'),
            // Change image genome to "Present and QA"
            this.catalogService.updateGenome(
                Array(3).fill(this.parrotId),
                ['chart', 'banner', 'poster'],
                Array(3).fill('Present and QA'), this.contentType
            )
            ,
            // Create a pending image update request
            this.imageUpdateService.postProdQA(this.parrotId, this.title, user)
        ])
        .then((res) => {
            this.qaRequestLoading = false;
            this.qaRequestExists = false;
            this.chartImageState = 'Present and QA';
            this.posterImageState = 'Present and QA';
            this.bannerImageState = 'Present and QA';
            this.toasterService.pop('success', 'Successfully completed the QA request and created a request for the production image to be reviewed');
        })
        .catch((err) => {
            this.qaRequestLoading = false;
            console.error('Failed to handle the QA request rejection: ', err.toString());
            this.toasterService.pop('error', 'Failed to handle the QA request rejection');
        });
    }

    handleProdQA(imageType: string) {
        const user = localStorage.getItem('userName');
        this.prodImageQALoading[imageType] = true;
        this.prodQAImageLoading = true;
        // We do not need to handle rejections as it is assumed that the QA person will upload a corrected image
        this.imageUpdateService.putImageQa(this.parrotId, user, 'PROD_QA', imageType, 'Present and QA', this.selectedTitle.content_type)
            .then((res) => {
                this.toasterService.pop('success', `Successfully approved the ${imageType} image in production!`);
                this.prodImageQALoading[imageType] = false;
                this.prodQAImageLoading = false;
                this[`${imageType}ImageState`] = 'Present';
            })
            .catch((err) => {
                this.prodImageQALoading[imageType] = false;
                this.prodQAImageLoading = false;
                console.error(`Failed to approve the ${imageType} image in production: ` + err.toString());
                this.toasterService.pop('error', `Failed to approve the ${imageType} image in production!`);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/image-update/image-update.component.ts